var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "handing global-page-base-layout",
      attrs: { loading: _vm.loading },
    },
    [
      _c("div", { staticClass: "conditions" }, [
        _c("div", { staticClass: "select-conditions" }, [
          _c(
            "div",
            { staticClass: "select-conditions-row" },
            [
              _c(
                "el-form",
                {
                  ref: "addPersonForm",
                  attrs: {
                    model: _vm.formFilter,
                    "label-position": "right",
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "受理号:" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "medium",
                                  placeholder: "请输入受理号",
                                },
                                model: {
                                  value: _vm.formFilter.caseId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formFilter, "caseId", $$v)
                                  },
                                  expression: "formFilter.caseId",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "案号:" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "medium",
                                  placeholder: "请输入案号",
                                },
                                model: {
                                  value: _vm.formFilter.caseNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formFilter, "caseNo", $$v)
                                  },
                                  expression: "formFilter.caseNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "状态" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "addpersonform-item",
                                  attrs: {
                                    size: "medium",
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value: _vm.formFilter.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formFilter, "status", $$v)
                                    },
                                    expression: "formFilter.status",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "待指定", value: "1" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "待审核", value: "2" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "已送达", value: "3" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "medium" },
                              on: { click: _vm.onFilter },
                            },
                            [_vm._v("筛选")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "handing-table" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "tooltip-effect": "dark",
                height: "calc(100vh - 280px)",
                "header-cell-style": { background: _vm.tableHeaderColor },
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "案号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.caseNo
                          ? _c(
                              "a",
                              {
                                staticClass: "link-style",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDetail(scope.row.caseId)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.caseNo))]
                            )
                          : _c(
                              "a",
                              {
                                staticClass: "link-style",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDetail(scope.row.caseId)
                                  },
                                },
                              },
                              [_vm._v("暂无案号")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "caseId", label: "受理号", width: "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "title", label: "裁决书标题" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.caseState[scope.row.status]) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "handingSecretaryName",
                  width: "120",
                  label: "办案秘书",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "reviewName",
                  label: "当前处理人",
                  width: "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "reason", width: "120", label: "拒绝原因" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "auditTime", label: "审核日期", width: "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "ctime", label: "申请时间" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "utime", label: "更新时间" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "150", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        (scope.row.status == 3 ? true : false)
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "medium" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleSend(scope.row)
                                  },
                                },
                              },
                              [_vm._v("【补正书送达】")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        (
                          scope.row.status == 5 || scope.row.status == 1
                            ? true
                            : false
                        )
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "medium" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("【证书编辑】")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        (scope.row.status == 4 ? true : false)
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handlPDF(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            【查看补正书】\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-sizes": _vm.pageSizes,
                  "page-size": 10,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("send-case", {
        ref: "sendCase",
        on: {
          handleShowing: _vm.updateShow,
          handleErrorShowing: _vm.updateErrorShow,
          initList: _vm.refreshPage,
        },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "下一环节流程审批人",
            visible: _vm.processVisible,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.processVisible = $event
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "70%" },
                      attrs: { placeholder: "选择审批人" },
                      model: {
                        value: _vm.processNextId,
                        callback: function ($$v) {
                          _vm.processNextId = $$v
                        },
                        expression: "processNextId",
                      },
                    },
                    _vm._l(_vm.optionArr, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.reviewName, value: item.reviewId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer text-right",
              staticStyle: { "padding-top": "10px" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.processVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loadingProcess },
                  on: {
                    click: function ($event) {
                      return _vm.handleProcess("1")
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "裁决书补正",
            visible: _vm.upcomingVisible,
            top: "0vh",
            fullscreen: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.upcomingVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { width: "50%", margin: "0 auto" } },
            [
              _c(
                "el-row",
                {
                  staticStyle: {
                    "padding-left": "100px",
                    "padding-right": "100px",
                  },
                },
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("div", { staticClass: "rule-header" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.dataContentForm.subject) +
                          "\n          "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("div", { staticClass: "rule-subject" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.dataContentForm.title) +
                          "\n          "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("div", { staticClass: "rule-caseno" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.dataContentForm.caseNo) +
                          "\n          "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.dataContent, function (item, index) {
                    return _c(
                      "el-col",
                      { key: index, attrs: { span: 24 } },
                      [
                        _c("el-input", {
                          staticClass: "rule-input",
                          attrs: {
                            type: "textarea",
                            autosize: "",
                            placeholder: "请输入内容",
                          },
                          model: {
                            value: item.text,
                            callback: function ($$v) {
                              _vm.$set(item, "text", $$v)
                            },
                            expression: "item.text",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "p-btn" },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { color: "red" },
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelete(index)
                                  },
                                },
                              },
                              [_vm._v("[删除]")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAdd(index)
                                  },
                                },
                              },
                              [_vm._v("[新增]")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer text-right",
              staticStyle: { "padding-top": "10px" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.upcomingVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loadingSave },
                  on: {
                    click: function ($event) {
                      return _vm.handleSave("1")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.ossFile.subject + "【" + _vm.ossFile.title + "】",
            visible: _vm.closeCaseVisible,
            size: "50%",
            direction: "rtl",
          },
          on: {
            "update:visible": function ($event) {
              _vm.closeCaseVisible = $event
            },
          },
        },
        [
          _c("iframe", {
            attrs: {
              src: _vm.ossFile.aliyunOssHref,
              width: "100%",
              height: "90%",
              frameborder: "0",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }